import React from "react";
import { SanityImageSourceExt } from "../../models/shared/SanityImageSourceExt";
import { isNullOrWhiteSpace } from "../../shared/string";
import { Picture } from "../Picture";
import { getHelpCardColorTheme, HelpCardColorTheme, HelpCardType } from "./HelpCard";
import HelpCardContainer, { Props as ContainerProps } from "./HelpCardContainer";

export type SanityHelpCardWithRating = {
  _type: HelpCardType.ReviewWithRating;
  title: string;
};

export interface Props extends ContainerProps, SanityHelpCardWithRating {
  rightPaddedTitle?: boolean;
  removeButtonXPadding?: boolean;
  buttonTransparent?: boolean;
  name: string;
  jobPosition: string;
  logo?: SanityImageSourceExt;
}

const HelpCardReviewWithRating = (props: Props) => {
  const { className, title, name, jobPosition, logo, ...containerProps } = props;

  const { textColor } = getHelpCardColorTheme(
    containerProps.colorTheme ?? HelpCardColorTheme.Default
  );

  const hasLogo = logo && logo?.asset?.url;

  return (
    <HelpCardContainer
      className={`${className ?? ""} py-10`}
      roundedClassName="md:rounded-lg "
      outsidePadding={false}
      innerAdditionalClassName={"items-center justify-center"}
      {...containerProps}
    >
      {!isNullOrWhiteSpace(title) && (
        <h3
          className={`font-bold ${textColor} text-center my-1 text-2xl md:text-3xl max-w-[36.625rem]`}
        >
          {title}
        </h3>
      )}
      <div className="self-center flex items-center gap-5 flex-wrap justify-center">
        <div
          className={`md:pr-5 flex-col ${
            hasLogo ? "md:border-r md:border-white md:border-opacity-60" : ""
          }`}
        >
          <p className="m-0 text-white">{name}</p>
          <p className="m-0 text-neutral-80 font-[400] text-sm">{jobPosition}</p>
        </div>

        {hasLogo && (
          <>
            <div className="w-full h-[1px] bg-white opacity-60 block md:hidden mx-[20%]" />

            <div className="w-full flex justify-center md:w-auto">
              <div>
                <Picture
                  image={logo}
                  presets={{
                    default: {
                      height: 30
                    }
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </HelpCardContainer>
  );
};

export default HelpCardReviewWithRating;
